import { render } from "./JobBoardReportPopin.vue?vue&type=template&id=4a99ac8c&scoped=true&ts=true"
import script from "./JobBoardReportPopin.vue?vue&type=script&lang=ts"
export * from "./JobBoardReportPopin.vue?vue&type=script&lang=ts"

import "./JobBoardReportPopin.vue?vue&type=style&index=0&id=4a99ac8c&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a99ac8c"]])

export default __exports__